import React, { useState } from 'react';

const ACCENT = '#C9A84C';

function formatTime(t) {
  const [h, m] = t.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
}

export default function ClientInfoStep({ service, slot, onSubmit, onBack, loading }) {
  const [form, setForm] = useState({
    name: '', phone: '', email: '', notes: '',
    mobile_location: '', mobile_event_type: '', mobile_people_count: '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const isMobile = service.is_mobile;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    if (isMobile && !form.mobile_location) return;
    onSubmit(form);
  };

  const displayDate = new Date(slot.date + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric'
  });

  const isSunday = new Date(slot.date + 'T00:00:00').getDay() === 0;
  const depositRequired = isSunday || isMobile;
  const depositAmount = depositRequired ? (parseFloat(slot.price) * 0.5).toFixed(0) : null;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '28px' }}>
        <button onClick={onBack} className="btn btn-ghost" style={{ padding: '8px 12px' }}>← Back</button>
        <h2 style={{ fontSize: '18px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Your Info
        </h2>
      </div>

      {/* Booking summary */}
      <div style={{
        background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.25)', borderRadius: '8px',
        padding: '20px', marginBottom: '24px',
      }}>
        <div style={{ fontSize: '10px', fontWeight: 700, color: ACCENT, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '12px' }}>
          Booking Summary
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: '16px' }}>{service.name}</div>
            <div style={{ color: '#888', fontSize: '13px', marginTop: '3px' }}>{displayDate} at {formatTime(slot.start_time)}</div>
            {slot.is_after_hours && (
              <span className="badge badge-after-hours" style={{ marginTop: '8px', display: 'inline-block' }}>After Hours</span>
            )}
          </div>
          <div style={{ color: ACCENT, fontSize: '28px', fontWeight: 900, lineHeight: 1, letterSpacing: '-0.02em' }}>
            ${parseFloat(slot.price || service.price).toFixed(0)}
          </div>
        </div>
        {depositRequired && (
          <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid rgba(201,168,76,0.15)', fontSize: '13px', color: '#888' }}>
            {isMobile ? 'Mobile service' : 'Sunday booking'} — <strong style={{ color: ACCENT }}>50% deposit (${depositAmount})</strong> collected when confirmed.
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        <div>
          <label className="label">Full Name *</label>
          <input className="input" placeholder="John Doe" value={form.name} onChange={e => set('name', e.target.value)} required />
        </div>
        <div>
          <label className="label">Phone Number *</label>
          <input className="input" placeholder="(561) 555-0100" type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} required />
        </div>
        <div>
          <label className="label">Email Address</label>
          <input className="input" placeholder="john@example.com" type="email" value={form.email} onChange={e => set('email', e.target.value)} />
          <p style={{ color: '#555', fontSize: '12px', marginTop: '5px' }}>Optional — for booking confirmation</p>
        </div>

        {isMobile && (
          <div style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.18)', borderRadius: '8px', padding: '18px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ color: ACCENT, fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em' }}>
              Mobile Service Details
            </div>
            <div>
              <label className="label">Event / Service Location *</label>
              <input className="input" placeholder="Address or venue name" value={form.mobile_location} onChange={e => set('mobile_location', e.target.value)} required={isMobile} />
            </div>
            <div>
              <label className="label">Event Type</label>
              <select className="input" value={form.mobile_event_type} onChange={e => set('mobile_event_type', e.target.value)}>
                <option value="">Select event type...</option>
                <option value="Private Event">Private Event</option>
                <option value="Wedding">Wedding</option>
                <option value="Birthday Party">Birthday Party</option>
                <option value="Corporate Event">Corporate Event</option>
                <option value="Graduation">Graduation</option>
                <option value="Photoshoot">Photoshoot</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <label className="label">Number of People</label>
              <input className="input" type="number" min="1" placeholder="How many people need service?" value={form.mobile_people_count} onChange={e => set('mobile_people_count', e.target.value)} />
            </div>
          </div>
        )}

        <div>
          <label className="label">Notes for Christian</label>
          <textarea className="input" placeholder="Any specific style, preferences, or requests..." rows={3} value={form.notes} onChange={e => set('notes', e.target.value)} style={{ resize: 'vertical' }} />
        </div>

        <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ padding: '18px', fontSize: '14px', marginTop: '4px' }}>
          {loading ? 'Setting up...' : 'Continue →'}
        </button>
      </form>
    </div>
  );
}
